import { ReactNode } from "react";
import styles from "../aic.module.css";
import { SET_ROW_HEADER_COLUMNS } from "./functions/interface";
import { useTableContext } from "./TableContextProvider";

/**
 * Button that increases the number of row header columns when editable.
 * Renders a disabled spacer when the increase action is not available.
 */
export const AitRowHeaderColumnsAdd = (): ReactNode => {
  const { state, dispatch } = useTableContext();
  const rowHeaderColumns =
    state?.processedTableData?.rowHeaderColumns !== undefined
      ? state.processedTableData.rowHeaderColumns
      : 1;
  return state &&
    state.editable &&
    state.processedTableData?.bodyData &&
    state.processedTableData?.bodyData.length > 0 &&
    state.processedTableData?.bodyData[0].rows.length > 0 &&
    rowHeaderColumns < state.processedTableData?.bodyData[0].rows[0].cells.length - 1 ? (
    <div
      id={`${state.id}-add-row-header-column`}
      className={[styles.aioxButton, styles.aioxPlus].join(" ")}
      aria-label="Increase row header columns"
      role="button"
      onClick={() =>
        dispatch({
          operation: SET_ROW_HEADER_COLUMNS,
          value: rowHeaderColumns + 1,
        })
      }
    />
  ) : (
    <div className={styles.aioxButton} />
  );
};

AitRowHeaderColumnsAdd.displayName = "AitRowHeaderColumnsAdd";
